<script>
  import { afterUpdate, createEventDispatcher } from 'svelte'

  export let name = '' // 識別用の名前
  export let title = '' // タイトル文字列
  export let buttonText = 'OK' // 確認ボタンのテキスト
  export let buttonClass = 'is-success' // 確認ボタンのクラス
  export let disableHeader = false // ヘッダを無効にする
  export let confirmHandler = event => true // 確認ボタンのハンドラ

  export let isCancelButtonVisible = true // キャンセルボタンの表示/非表示フラグ
  export let isConfirmable = true // 確認ボタンの有効無効フラグ

  export const show = () => (isActive = isShowing = true)
  export const hide = () => (isActive = false)

  const dispatch = createEventDispatcher()

  let isActive = false // 表示のオンオフ フラグ
  let isShowing = false // モーダル表示中 フラグ
  let body // モーダルのbody部分

  // モーダルを表示するたびにスクロール位置をリセットする
  afterUpdate(() => {
    if (!isShowing) return
    body.scrollTop = 0
    isShowing = false
  })

  // 確認ボタンを押したとき
  const confirm = event => {
    // confirmHandler の処理が通ったら閉じる
    if (confirmHandler(event)) hide()
  }

  // キャンセル ボタンを押したとき
  const cancel = event => {
    const shouldContinue = dispatch('cancel', event, { cancelable: true })
    if (shouldContinue) hide()
  }
</script>

<div class="modal" data-testid={`${name}ModalCard`} class:is-active={isActive}>
  <!-- バックグラウンドを押したら閉じる -->
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <div class="modal-background" on:click={hide} />
  <div class="modal-card">
    <header class="modal-card-head" class:is-narrow={disableHeader}>
      <p class="modal-card-title">{disableHeader ? '' : title}</p>
      <!-- 閉じる×ボタン -->
      <button class="delete" aria-label="close" on:click={hide} />
    </header>

    <section class="modal-card-body" bind:this={body}>
      {#if disableHeader}
        <!-- ヘッダ無効時はここにタイトルを表示する -->
        <p class="modal-card-title">{title}</p>
      {/if}
      <slot />
    </section>

    <footer class="modal-card-foot">
      <slot name="footer" />

      <div class="foot-buttons">
        <!-- キャンセルボタン -->
        {#if isCancelButtonVisible}
          <button
            class="button"
            data-testid={`${name}CancelButton`}
            on:click={cancel}>キャンセル</button
          >
        {:else}
          <!-- 確認ボタンを右寄せにするための空要素 -->
          <div />
        {/if}
        <!-- 確認ボタン -->
        <button
          class={`button ${buttonClass}`}
          data-testid={`${name}ConfirmButton`}
          disabled={!isConfirmable}
          on:click={confirm}>{buttonText}</button
        >
      </div>
    </footer>
  </div>
</div>

<style>
  .modal-card-head.is-narrow {
    padding: 6px;
  }

  .modal-card-foot {
    flex-direction: column;
  }

  .foot-buttons {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
</style>
